import React from "react";
import PaymentAdvancesCustomers from "../Customers";

export default function PaymentAdvancesProviders() {
  return <PaymentAdvancesCustomers type="proveedores" />;
}
